import { useEffect, useState } from "react";
import {
  Modal,
  ScrollView,
  View,
  TouchableOpacity,
  Image,
  Pressable,
  Text,
} from "react-native";
import { HelperText } from "react-native-paper";
import AdminInput from "../../../../components/AdminInput";
import AdminSwitch from "../../../../components/AdminSwitch";
import AdminAlert from "../../../../components/AdminAlert";
import {
  SubTitle,
  SmallText,
  FooterText,
} from "../../../../config/theme/globalStyles";
import Button from "../../../../components/Button";
import {
  ViewTextInput,
  ViewButton,
  ViewDescription,
  ModalBackground,
  ModalContainer,
  Header,
  CloseButton,
  Content,
} from "./../style";
import { AntDesign, Feather } from "@expo/vector-icons";
import CurrencyInput from "react-native-currency-input";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import THEME from "../../../../config/theme";
import { ADMIN_COLORS, ADMIN_FONT } from "../../../../config/theme/adminColors";
import {
  textValidator,
  daysValidator,
  linkValidator,
  firestoreAutoId,
} from "../../../../utils/validators";
import { firestore, storage } from "../../../../services/firebase";
import { editCourseOnStripe } from "../service/product-service";
import { InfoBanner, Field, FieldLabel, Hint, useResponsive } from "../formStyles";
import { CatalogEquivalentsPicker } from "../../../../components/CatalogEquivalentsPicker";
import { ProductCategoryPicker } from "../../../../components/ProductCategoryPicker";
import { queryClient } from "../../../../queries/queryClient";
import { useCatalogProducts } from "../../../../queries/useCatalogProducts";
import { useCategories } from "../../../../queries/useCategories";
import { COURSES } from "../../../../constants/entities";
import { syncCatalogEquivalentIds } from "../../../../utils/syncCatalogEquivalentIds";
import { getInvalidCatalogEquivalents } from "../../../../utils/catalogContentSignature";
import { useRemoteConfigContext } from "../../../../contexts/useRemoteConfigContext";
import {
  CheckoutLinksCard,
  buildCourseCheckoutUrl,
  useCheckoutDomain,
} from "./CheckoutLinks";
import { hasOutsideAboutPage } from "../../../../config/data";

const functions = getFunctions();

const CreateStripeCourseModal = ({
  isVisible,
  onClose,
  onCreate,
  plansInfo,
  user,
  selectedCourse,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [titleCourse, setTitleCourse] = useState({ value: "", error: "" });
  const [priceCourse, setPriceCourse] = useState({ value: "", error: "" });
  const [priceCourseStripe, setPriceCourseStripe] = useState();
  const [valueCourseWithRS, setValueCourseWithRS] = useState("");
  const [smallText, setSmallText] = useState("");
  const [isCourseActive, setIsCourseActive] = useState(true);
  const [validityCourse, setValidityCourse] = useState({
    value: "",
    error: "",
  });
  const [salesPageUrl, setSalesPageUrl] = useState("");
  const [course, setCourse] = useState({ infos: [""] });
  const { infos } = course;
  const [youtube, setYoutube] = useState({ value: "", error: "" });
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [message, setMessege] = useState(null);
  const [image, setImage] = useState("");
  const [descriptionFirst, setDescriptionFirst] = useState("");
  const [uploadingImage, setUploadingImage] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  // Vitrine de Produtos: reaproveita a "Imagem do curso" já existente acima —
  // não precisa de um segundo upload. Só disponível em edição (o curso já
  // precisa existir para poder ser vinculado como equivalente de outro item).
  const [catalogOrder, setCatalogOrder] = useState("0");
  const [equivalentIds, setEquivalentIds] = useState([]);
  const [productCategoryId, setProductCategoryId] = useState(null);
  const isEditMode = !!selectedCourse?.id;
  // Vitrine fields/validation only apply when the Product Showcase is enabled —
  // otherwise Stripe clients without a course image could no longer edit courses.
  const { hasProductCatalog } = useRemoteConfigContext();
  const showVitrineFields = isEditMode && !!hasProductCatalog;
  // Imagem já salva (ou a recém-enviada, que fica em `image`) para a prévia.
  const currentImageUrl =
    image || selectedCourse?.image || selectedCourse?.backgroundImage?.url || "";
  const { isMobile } = useResponsive();
  const { data: catalogProducts = [] } = useCatalogProducts(showVitrineFields);
  const { data: categories = [] } = useCategories();

  // Link de checkout do produto avulso — mesmo card usado no modal de plano.
  // Só na edição: o `priceId` só existe depois que a Stripe cria o preço.
  const showCheckoutLinks = isEditMode && hasOutsideAboutPage;
  const {
    domain: checkoutDomain,
    loading: loadingCheckoutDomain,
    hasError: checkoutDomainError,
    reload: reloadCheckoutDomain,
  } = useCheckoutDomain(isVisible && showCheckoutLinks);

  const courseCheckoutUrl = buildCourseCheckoutUrl(
    checkoutDomain,
    selectedCourse,
  );
  const checkoutLinks = courseCheckoutUrl
    ? [
        {
          key: "course",
          label: "Pagamento único",
          hint: selectedCourse?.days
            ? `acesso por ${selectedCourse.days} dias`
            : undefined,
          url: courseCheckoutUrl,
        },
      ]
    : [];

  const resetFormFields = () => {
    setTitleCourse({ value: "", error: "" });
    setSmallText("");
    setIsCourseActive(true);
    setCourse({ infos: [""] });
    setPriceCourse({ value: "", error: "" });
    setPriceCourseStripe();
    setValueCourseWithRS("");
    setValidityCourse({ value: "", error: "" });
    setYoutube({ value: "", error: "" });
    setSalesPageUrl("");
    setVisibleAlert(false);
    setMessege(null);
    setImage("");
    setDescriptionFirst("");
    setUploadingImage(false);
    setUploadProgress(0);
    setCatalogOrder("0");
    setEquivalentIds([]);
    setProductCategoryId(null);
  };

  useEffect(() => {
    if (!isVisible) return;

    if (isEditMode) {
      // Espelha TODOS os campos do documento em `courses/{id}` — os nomes seguem o
      // que a createCourse (functions/index.js) grava na criação.
      const currentInfo = Array.isArray(selectedCourse?.infos)
        ? selectedCourse.infos
        : [];
      setTitleCourse({ value: selectedCourse?.title || "", error: "" });
      // `archived` é a fonte da verdade do status (a lista usa a mesma regra):
      // ativo é archived === false, e qualquer outro valor conta como inativo.
      setIsCourseActive(selectedCourse?.archived === false);
      setCourse({ infos: currentInfo.length ? [...currentInfo] : [""] });
      setDescriptionFirst(currentInfo?.[0] || "");
      setImage(selectedCourse?.image || "");
      setValidityCourse({
        value: selectedCourse?.days != null ? String(selectedCourse.days) : "",
        error: "",
      });
      setSalesPageUrl(selectedCourse?.salesPageUrl || "");
      setSmallText(selectedCourse?.smallText || "");
      setYoutube({ value: selectedCourse?.previewVideo || "", error: "" });
      setVisibleAlert(false);
      setMessege(null);
      setUploadingImage(false);
      setUploadProgress(0);
      setValueCourseWithRS(
        selectedCourse?.price || selectedCourse?.valueCourseWithRS || "",
      );
      const numericPrice =
        parseFloat(
          (selectedCourse?.price || selectedCourse?.valueCourseWithRS || "")
            .toString()
            .replace(/[^\d.,]/g, "")
            .replace(",", "."),
        ) || 0;
      setPriceCourse({ value: numericPrice, error: "" });
      setPriceCourseStripe(numericPrice * 100);
      setCatalogOrder(selectedCourse?.order != null ? String(selectedCourse.order) : "0");
      setEquivalentIds(
        Array.isArray(selectedCourse?.equivalentIds) ? selectedCourse.equivalentIds : [],
      );
      setProductCategoryId(selectedCourse?.productCategoryId ?? null);
      return;
    }

    resetFormFields();
  }, [isVisible, isEditMode, selectedCourse]);

  const validation = () => {
    const titleError = textValidator(titleCourse.value);
    const priceError = textValidator(priceCourse.value);
    const daysError = daysValidator(Number(validityCourse.value));
    const youtubeError = linkValidator(youtube.value);

    if (titleError || daysError || priceError) {
      setTitleCourse({ ...titleCourse, error: titleError });
      setPriceCourse({ ...priceCourse, error: priceError });
      setValidityCourse({ ...validityCourse, error: daysError });
      setYoutube({ ...youtube, error: youtubeError });
      setLoadingSave(false);
      return;
    }
    return false;
  };

  const showAlert = (message) => {
    setVisibleAlert(true);
    setMessege(message);
  };

  const hideAlert = (status) => {
    setVisibleAlert(status);
  };

  const handleUploadImage = async (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    try {
      setUploadingImage(true);
      const sanitizedFileName = String(file.name || "image")
        .replace(/\s+/g, "_")
        .replace(/[^a-zA-Z0-9._-]/g, "");
      const fileName = `${firestoreAutoId()}_${sanitizedFileName}`;
      const storageRef = ref(storage, fileName);
      const uploadTask = uploadBytesResumable(storageRef, file, {
        contentType: file.type || "image/png",
      });

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          );
          setUploadProgress(progress);
        },
        (error) => {
          console.error("Erro no upload da imagem:", error);
          showAlert(
            `Erro ao fazer upload da imagem (${error?.code || "desconhecido"}).`,
          );
          setUploadingImage(false);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          setImage(downloadURL);
          setUploadingImage(false);
          showAlert("Imagem enviada com sucesso!");
        },
      );
    } catch (error) {
      console.error("Erro no upload da imagem:", error);
      showAlert("Erro ao fazer upload da imagem.");
      setUploadingImage(false);
    }
  };

  const addCourse = () => {
    setLoadingSave(true);
    // `validation()` devolve false quando está tudo certo (e undefined quando
    // marcou erros nos campos). Chamada UMA vez: antes ela rodava duas, aplicando
    // os setState de erro em duplicidade.
    const isValid = validation() === false;
    let myData = {
      titleCourseValue: titleCourse.value,
      priceCourseStripe: Number(priceCourseStripe || 0).toFixed(0),
      youtubeValue: youtube.value,
      validityCourseValue: validityCourse.value,
      smallText: smallText,
      salesPageUrl: salesPageUrl,
      hasOutsidePage: salesPageUrl.length > 0 ? true : false,
      infosCourse: infos,
      valueCourseWithRS: valueCourseWithRS,
      image: image || "",
      archived: isCourseActive ? false : true,
      user: user,
    };
    if (isValid) {
      const addProductOnStripe = httpsCallable(functions, "addProductOnStripe");
      addProductOnStripe(myData)
        .then(() => {
          showAlert("Produto adicionado com sucesso!");
          setTimeout(() => {
            resetFormFields();
            if (onCreate) onCreate();
            onClose();
          }, 1200);
        })
        .catch((error) => {
          // Antes o erro era engolido em silêncio: o spinner parava e o modal
          // ficava aberto sem explicar nada para quem estava criando o produto.
          console.error("[addCourse] ERRO:", error);
          showAlert(
            "Erro ao adicionar produto: " + (error?.message || "desconhecido"),
          );
        })
        .finally(() => {
          setLoadingSave(false);
        });
    }
  };

  // Validação da edição: só os campos obrigatórios do formulário. Sem isso um
  // campo vazio sobrescreveria o valor já salvo (ex.: days viraria 0).
  const editValidation = () => {
    const titleError = textValidator(titleCourse.value);
    const daysError = daysValidator(validityCourse.value);
    const youtubeError = linkValidator(youtube.value);

    if (titleError || daysError || youtubeError) {
      setTitleCourse({ ...titleCourse, error: titleError });
      setValidityCourse({ ...validityCourse, error: daysError });
      setYoutube({ ...youtube, error: youtubeError });
      return false;
    }
    return true;
  };

  const handleEditCourse = async () => {
    if (!selectedCourse?.id) return;
    if (!editValidation()) return;

    setLoadingSave(true);
    try {
      if (showVitrineFields) {
        const selfProduct = catalogProducts.find((item) => item.id === selectedCourse.id);
        const invalidEquivalents = getInvalidCatalogEquivalents(
          selfProduct,
          equivalentIds,
          catalogProducts,
          categories
        );

        if (invalidEquivalents.length > 0) {
          showAlert(
            "Remova os equivalentes com conteúdo diferente antes de salvar. Só é possível vincular itens com os mesmos módulos."
          );
          setLoadingSave(false);
          return;
        }

        const vitrineImageUrl =
          image || selectedCourse?.image || selectedCourse?.backgroundImage?.url || "";
        if (!vitrineImageUrl) {
          showAlert("Adicione a imagem do curso antes de salvar — ela é usada como capa na vitrine.");
          setLoadingSave(false);
          return;
        }
      }

      const currentInfo = Array.isArray(selectedCourse?.infos)
        ? [...selectedCourse.infos]
        : [];
      if (currentInfo.length === 0) currentInfo.push("");
      currentInfo[0] = descriptionFirst || "";

      const oldPrice = (
        selectedCourse?.price ||
        selectedCourse?.valueCourseWithRS ||
        ""
      ).toString();
      const priceChanged = valueCourseWithRS && valueCourseWithRS !== oldPrice;

      // 1) Salva no Firestore PRIMEIRO (nunca depende do Stripe). Só o preço vive
      // no Stripe; todo o resto do formulário é gravado aqui, com os mesmos nomes
      // de campo usados na criação (createCourse em functions/index.js).
      const salesPage = salesPageUrl || "";
      const firestoreData = {
        title: titleCourse.value,
        archived: !isCourseActive,
        days: Number(validityCourse.value),
        smallText: smallText || "",
        salesPageUrl: salesPage,
        hasOutsidePage: salesPage.length > 0,
        previewVideo: youtube.value || null,
        image: image || "",
        infos: currentInfo,
        ...(showVitrineFields && {
          // Keep the "Vitrine" column toggle from the Products table: forcing
          // `true` here re-published hidden courses on every edit.
          showInCatalog: selectedCourse?.showInCatalog !== false,
          order: Number.isFinite(Number(catalogOrder)) ? Number(catalogOrder) : 0,
          equivalentIds,
          productCategoryId,
        }),
      };

      // A vitrine do aluno lê `backgroundImage.url || image` (ClickCourse). Em
      // cursos que já têm backgroundImage, gravar só `image` salva a URL nova mas
      // o aluno continua vendo a antiga — por isso espelhamos a URL enviada.
      // Caminho com ponto para não apagar os irmãos do map (name/urlVertical).
      const uploadedNewImage =
        !!image && image !== (selectedCourse?.image || "");
      if (uploadedNewImage && selectedCourse?.backgroundImage) {
        firestoreData["backgroundImage.url"] = image;
      }
      console.log(
        "[editCourse] salvando no Firestore:",
        JSON.stringify(firestoreData),
      );
      const previousEquivalentIds = Array.isArray(selectedCourse?.equivalentIds)
        ? selectedCourse.equivalentIds
        : [];

      await updateDoc(
        doc(firestore, "courses", selectedCourse.id),
        firestoreData,
      );

      if (showVitrineFields) {
        await syncCatalogEquivalentIds({
          collectionName: COURSES,
          docId: selectedCourse.id,
          previousEquivalentIds,
          nextEquivalentIds: equivalentIds,
        });
      }

      queryClient.invalidateQueries({ queryKey: ["catalogProducts"] });

      // 2) Atualiza preço no Stripe se mudou
      if (priceChanged) {
        const stripeAmount = Number(priceCourseStripe || 0).toFixed(0);
        console.log("[editCourse] stripeAmount (centavos):", stripeAmount);

        if (!stripeAmount || Number(stripeAmount) <= 0) {
          showAlert("Imagem salva, mas valor do curso inválido.");
          setLoadingSave(false);
          return;
        }

        const payload = {
          courseId: selectedCourse.id,
          priceCourseStripe: Number(stripeAmount),
          valueCourseWithRS: valueCourseWithRS,
          user: user,
        };
        console.log(
          "[editCourse] chamando editCourseOnStripe com:",
          JSON.stringify(payload),
        );

        const result = await editCourseOnStripe(payload);
        console.log(
          "[editCourse] resultado Stripe:",
          JSON.stringify(result?.data),
        );
      }

      queryClient.invalidateQueries({ queryKey: ["catalogProducts"] });
      showAlert("Curso atualizado com sucesso!");
      setTimeout(() => {
        resetFormFields();
        if (onCreate) onCreate();
        onClose();
      }, 1200);
    } catch (error) {
      console.error("[editCourse] ERRO:", error);
      console.error(
        "[editCourse] code:",
        error?.code,
        "| message:",
        error?.message,
        "| details:",
        error?.details,
      );
      showAlert(
        "Erro ao atualizar curso: " + (error?.message || "desconhecido"),
      );
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <Modal animationType="fade" visible={isVisible} transparent={true}>
      <ModalBackground>
        <ModalContainer>
          <ScrollView
            showsVerticalScrollIndicator={true}
            style={{ width: "100%" }}
          >
            <Header>
              <SubTitle padding="0.2rem 0rem" color={ADMIN_COLORS.ink}>
                {isEditMode ? "Editar Curso:" : "Adicionar Novo Produto:"}
              </SubTitle>
              <CloseButton
                onPress={() => {
                  resetFormFields();
                  onClose();
                }}
              >
                <Feather name="x" size={20} color={ADMIN_COLORS.ink} />
              </CloseButton>
            </Header>
            <Content>
              <InfoBanner variant="info">
                Produtos são vendas online com pagamentos SEM recorrência, são
                pagos uma ÚNICA vez e você escolhe a VALIDADE que eles ficarão
                disponíveis para seus alunos. Pode ser uma compra válida por 1
                dia, 30 dias (1mês) ou até o prazo máximo de 365 dias (1 ano)! A
                dica aqui é você vender aulas ao vivo avulsas, séries com aulas
                gravadas e desafios, cursos online, rituais.
              </InfoBanner>

              <FieldLabel>Nome do Produto:</FieldLabel>
              <AdminInput
                placeholder="Digitar nome"
                keyboardType="default"
                returnKeyType="go"
                value={titleCourse.value}
                onChangeText={(text) => {
                  setTitleCourse({ value: text, error: "" });
                }}
              />

              <HelperText type="error" visible={titleCourse.error}>
                {titleCourse.error}
              </HelperText>

              {/* Rótulo e switch na mesma linha: empilhados, o controle ficava
                  solto embaixo do texto e parecia pertencer ao campo seguinte. */}
              <Field
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 16,
                }}
              >
                <FieldLabel>
                  Status do curso: {isCourseActive ? "Ativo" : "Inativo"}
                </FieldLabel>
                <AdminSwitch
                  value={isCourseActive}
                  onValueChange={(value) => setIsCourseActive(value)}
                />
              </Field>

              {showCheckoutLinks ? (
                <CheckoutLinksCard
                  subtitle="Link de venda deste produto. Quem abrir vai direto para o cadastro e o pagamento."
                  links={checkoutLinks}
                  loading={loadingCheckoutDomain}
                  hasError={checkoutDomainError}
                  onReload={reloadCheckoutDomain}
                  emptyMessage="Este produto ainda não tem preço criado na Stripe, então não há link de checkout."
                />
              ) : null}

              <Field>
                <FieldLabel>Imagem do curso:</FieldLabel>
                <ViewTextInput>
                  <View style={{ marginTop: 8, alignItems: "flex-start" }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleUploadImage}
                    />
                  </View>
                </ViewTextInput>
                {/* O seletor de arquivo não tem como vir preenchido; a prévia é o
                    equivalente para a edição. Mesma precedência que a vitrine do
                    aluno usa (ClickCourse): backgroundImage.url primeiro. */}
                {!!currentImageUrl && (
                  <Image
                    source={{ uri: currentImageUrl }}
                    style={{
                      width: 160,
                      height: 90,
                      borderRadius: 8,
                      marginTop: 10,
                      borderWidth: 1,
                      borderColor: ADMIN_COLORS.border,
                    }}
                    resizeMode="cover"
                  />
                )}
              </Field>

              {showVitrineFields && (
                <Field>
                  <FieldLabel>Vitrine de Produtos</FieldLabel>
                  <Hint>
                    Este curso aparece na prateleira Produtos do app/web. A imagem do curso
                    (acima) é obrigatória e serve como capa na vitrine.
                  </Hint>

                  <View style={{ marginTop: 12 }}>
                    <FieldLabel>Categoria de produtos</FieldLabel>
                    <Hint>
                      A prateleira em que este curso aparece na página principal (ex.: "Cursos teóricos",
                      "Formações"). Sem categoria, cai numa prateleira genérica "Produtos".
                    </Hint>
                    <View style={{ marginTop: 8 }}>
                      <ProductCategoryPicker
                        value={productCategoryId}
                        onChange={setProductCategoryId}
                      />
                    </View>
                  </View>

                  <View style={{ marginTop: 12 }}>
                    <FieldLabel>Ordem</FieldLabel>
                    <AdminInput
                      placeholder="0"
                      keyboardType="numeric"
                      value={catalogOrder}
                      onChangeText={(text) => setCatalogOrder(text.replace(/[^0-9]/g, ""))}
                    />
                  </View>

                  <View style={{ marginTop: 12 }}>
                    <FieldLabel>Produtos equivalentes</FieldLabel>
                    <Hint>
                      Evite cards repetidos na vitrine de produtos. Vincule aqui outros produtos,
                      planos ou cursos que são o mesmo conteúdo (ex.: turmas diferentes de um
                      curso ou formas de pagamento diferentes, como à vista e parcelado). Na
                      página principal da Vitrine, o aluno vê um único card para todos os
                      produtos vinculados — mesma imagem de capa.
                    </Hint>
                    <View style={{ marginTop: 8 }}>
                      <CatalogEquivalentsPicker
                        selfId={selectedCourse?.id}
                        value={equivalentIds}
                        onChange={setEquivalentIds}
                      />
                    </View>
                  </View>
                </Field>
              )}

              <Field>
                <FieldLabel>Descrição do Produto:</FieldLabel>
                {isEditMode && (
                  <AdminInput
                    placeholder="Digite a descrição do curso"
                    keyboardType="default"
                    returnKeyType="go"
                    value={descriptionFirst}
                    onChangeText={(text) => setDescriptionFirst(text)}
                    multiline
                  />
                )}
              </Field>

              {uploadingImage && (
                <FooterText color="#2e2e2e" padding="0.5rem 0rem">
                  Enviando imagem... {uploadProgress}%
                </FooterText>
              )}
              {!uploadingImage && !!image && (
                <AdminAlert variant="success">
                  Imagem pronta para salvar.
                </AdminAlert>
              )}
              {!isEditMode && (
                <>
                  {Array.isArray(infos) &&
                    infos.map((item, index) => (
                      <ViewTextInput key={index}>
                        <AdminInput
                          placeholder="Digitar descrição"
                          keyboardType="default"
                          returnKeyType="go"
                          value={item}
                          onChangeText={(value) => {
                            infos[index] = value;
                            setCourse((prevState) => {
                              return { ...prevState, infos: infos };
                            });
                          }}
                        />
                      </ViewTextInput>
                    ))}
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-evenly",
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        infos.push("");
                        setCourse((prevState) => {
                          return { ...prevState, infos: infos };
                        });
                      }}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingHorizontal: 8,
                      }}
                    >
                      <AntDesign name="plus" size={18} color="#2e2e2e" />
                      <FooterText color="#2e2e2e" padding="0.5rem">
                        Adicionar parágrafo
                      </FooterText>
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={() => {
                        infos.pop();
                        setCourse((prevState) => {
                          return { ...prevState, infos: infos };
                        });
                      }}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingHorizontal: 8,
                      }}
                    >
                      <AntDesign name="minus" size={18} color="#2e2e2e" />
                      <FooterText color="#2e2e2e" padding="0.5rem">
                        Remover parágrafo
                      </FooterText>
                    </TouchableOpacity>
                  </View>
                </>
              )}

              <Field>
                <FieldLabel>Valor do Produto (R$):</FieldLabel>
                {/* O CurrencyInput só cuida da máscara: quem desenha o campo é o
                    AdminInput, via `renderTextInput` (o `ref` encaminhado pela lib
                    é descartado porque o AdminInput não é um forwardRef). */}
                <CurrencyInput
                  prefix="R$"
                  delimiter=","
                  separator="."
                  precision={2}
                  value={priceCourse.value}
                  onChangeValue={(text) => {
                    setPriceCourse({ value: Number(text), error: "" });
                    setPriceCourseStripe(Number(text) * 100);
                  }}
                  onChangeText={(value) => {
                    setValueCourseWithRS(value);
                  }}
                  renderTextInput={({ ref, ...inputProps }) => (
                    <AdminInput
                      {...inputProps}
                      placeholder="Ex.: 100.00"
                      returnKeyType="go"
                    />
                  )}
                />
                <HelperText type="error" visible={priceCourse.error}>
                  {priceCourse.error}
                </HelperText>
              </Field>

              <Field>
                <FieldLabel>Validade de acesso (em dias): </FieldLabel>
                <AdminInput
                  placeholder="Ex.: 90"
                  keyboardType="decimal-pad"
                  returnKeyType="go"
                  value={validityCourse.value}
                  onChangeText={(text) => {
                    setValidityCourse({
                      value: text.replace(/[^0-9]/g, ""),
                      error: "",
                    });
                  }}
                />
                <HelperText type="error" visible={validityCourse.error}>
                  {validityCourse.error}
                </HelperText>
              </Field>

              <Field>
                <FieldLabel>Página de vendas do produto (opcional):</FieldLabel>
                <InfoBanner variant="warn">
                  Caso você não tenha página de vendas específica para este
                  produto, não adicione nada neste campo e a página será a
                  padrão já existente no aplicativo
                </InfoBanner>
                <AdminInput
                  placeholder="Ex.: https://www.yourdomain.com/product1"
                  keyboardType="default"
                  returnKeyType="go"
                  value={salesPageUrl}
                  onChangeText={(value) => {
                    setSalesPageUrl(value);
                  }}
                />
              </Field>

              <Field>
                <FieldLabel>Texto em destaque:</FieldLabel>
                <AdminInput
                  placeholder="Ex.: ✔ Acesso válido por 1 ano"
                  keyboardType="default"
                  returnKeyType="go"
                  value={smallText}
                  onChangeText={(value) => {
                    setSmallText(value);
                  }}
                />
              </Field>

              <Field>
                <FieldLabel>Vídeo de vendas Youtube:</FieldLabel>
                <AdminInput
                  placeholder="Colar link do youtube"
                  keyboardType="default"
                  returnKeyType="go"
                  value={youtube.value}
                  onChangeText={(text) => {
                    setYoutube({ value: text, error: "" });
                  }}
                />
                <HelperText type="error" visible={youtube.error}>
                  {youtube.error}
                </HelperText>
              </Field>

              {visibleAlert && (
                <AdminAlert
                  variant={message?.includes("sucesso") ? "success" : "error"}
                >
                  {message}
                </AdminAlert>
              )}

              <View
                style={[
                  styles.footer,
                  isMobile && { flexDirection: "column-reverse" },
                ]}
              >
                <Pressable
                  onPress={() => {
                    resetFormFields();
                    onClose();
                  }}
                  disabled={loadingSave}
                  style={({ hovered }) => [
                    styles.btn,
                    styles.btnSecondary,
                    hovered && { backgroundColor: "#E5E7EB" },
                  ]}
                >
                  <Text
                    style={[
                      styles.btnText,
                      { color: ADMIN_COLORS.secondaryText },
                    ]}
                  >
                    Cancelar
                  </Text>
                </Pressable>
                <Pressable
                  onPress={() =>
                    isEditMode ? handleEditCourse() : addCourse()
                  }
                  disabled={loadingSave}
                  style={({ hovered }) => [
                    styles.btn,
                    styles.btnPrimary,
                    hovered && { backgroundColor: ADMIN_COLORS.accentDark },
                    loadingSave && { opacity: 0.7 },
                  ]}
                >
                  <Text
                    style={[
                      styles.btnText,
                      { color: ADMIN_COLORS.primaryText },
                    ]}
                  >
                    {loadingSave ? "Salvando..." : "Salvar"}
                  </Text>
                </Pressable>
              </View>
            </Content>
          </ScrollView>
        </ModalContainer>
      </ModalBackground>
    </Modal>
  );
};

export default CreateStripeCourseModal;

const styles = {
  footer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 12,
    padding: 20,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: ADMIN_COLORS.border,
    backgroundColor: ADMIN_COLORS.surfaceSubtle,
  },
  btn: {
    minHeight: 44,
    borderRadius: 10,
    paddingHorizontal: 22,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  btnPrimary: { backgroundColor: ADMIN_COLORS.accent },
  btnSecondary: { backgroundColor: ADMIN_COLORS.secondaryBg },
  btnText: { fontFamily: ADMIN_FONT, fontSize: 14, fontWeight: "600" },
};
